import React from 'react';
import { useLocation } from 'react-router-dom';
import "./Report.css"
import FakturaunderlagReportContainer from './FakturaunderlagReportContainer'
import { Form, Row, Col, Alert, Container } from 'react-bootstrap';
import { BsExclamationCircleFill } from "react-icons/bs";

const Report = ({ errorMessage }) => {
  const location = useLocation();

  // Extract report type from URL path
  const reportType = location.pathname.split('/rapporter/')[1] || '';

  const renderForm = () => {
    switch (reportType) {
      case "fakturaunderlag":
        return (
            <div className='FormContainer'>
              <FakturaunderlagReportContainer/>
            </div>
        );
      case "fakturaunderlag-meny":
        return (
          <div className='FormContainer'>
            <div className="FakturaForm">
              <Form>
                <h3>Fakturaunderlag</h3>
                <Form.Group controlId="invoiceNumber">
                  <Form.Label>Fakturanummer</Form.Label>
                  <Form.Control type="text" placeholder="Ange fakturanummer" />
                </Form.Group>
                <Form.Group controlId="amount">
                  <Form.Label>Belopp</Form.Label>
                  <Form.Control type="number" placeholder="Ange belopp" />
                </Form.Group>
              </Form>
            </div>
          </div>
        );
      case 'annat':
        return (
          <div className='FormContainer'>
            <div className="AnnatForm">
              <Form>
                <h3>Annat</h3>
                <Form.Group controlId="customField">
                  <Form.Label>Anpassat fält</Form.Label>
                  <Form.Control type="text" placeholder="Ange information" />
                </Form.Group>
              </Form>
            </div>
          </div>
        );
      default:
        return (
          <div className='FormContainer'>
            <Alert variant="info">
              Välj en rapporttyp från menyn ovan för att komma igång.
            </Alert>
          </div>
        );
    }
  };

  return (
    <div className="Report">
      <Container id={"opticianMainGrid"}>
        {errorMessage &&
          <Row>
            <Col xs={12} md={12} lg={12}>
              <Alert variant={"danger"}>
                <b><BsExclamationCircleFill /> {errorMessage}</b>
              </Alert>
            </Col>
          </Row>
        }
        <Container>
        <Row className='mb-2'>
          <Col xs={12} md={12} lg={12}>
            <h1>Rapporter</h1>
          </Col>
        </Row>
        <Row className='content-Container'>
            {renderForm()}
        </Row>
        </Container>
      </Container>
    </div>
  );
};


export default Report;
